module.exports = __webpack_public_path__ + "img/testimonial-2.133b63c3.jpg";